import {
  ADD_SCHEDULE,
  DELETE_SCHEDULE,
  GET_ALL_SCHEDULES,
  SET_SCHEDULES,
  UPDATE_SCHEDULE,
  UPDATE_SCHEDULES,
} from "../actions/schedule.action";

const initialState = {
  schedules: {},
};

// Helper function to sort schedules by name
const sortSchedulesByName = (schedules) => {
  if (!Array.isArray(schedules)) return schedules;
  return [...schedules].sort((a, b) => {
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

// Helper function to sort schedules by property name first, then by schedule name
const sortSchedulesByPropertyThenName = (schedules, properties = []) => {
  if (!Array.isArray(schedules)) return schedules;
  
  return [...schedules].sort((a, b) => {
    // Find property names for comparison
    const propertyA = properties.find(p => p.id === a.propertyId);
    const propertyB = properties.find(p => p.id === b.propertyId);
    
    const propertyNameA = (propertyA?.name || '').toLowerCase();
    const propertyNameB = (propertyB?.name || '').toLowerCase();
    
    // First sort by property name
    const propertyComparison = propertyNameA.localeCompare(propertyNameB);
    if (propertyComparison !== 0) {
      return propertyComparison;
    }
    
    // Then sort by schedule name
    const nameA = (a.name || '').toLowerCase();
    const nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

// Helper function to sort schedules within an object structure
const sortSchedulesInObject = (schedulesObj) => {
  const sorted = {};
  for (const propertyId in schedulesObj) {
    sorted[propertyId] = sortSchedulesByName(schedulesObj[propertyId]);
  }
  return sorted;
};

const scheduleReducer = (state = initialState, action) => {
  // console.log(action, "action");
  switch (action.type) {
    case GET_ALL_SCHEDULES:
      const mergedSchedules = {
        ...state.schedules,
        ...action.payload,
      };
      return {
        ...state,
        schedules: sortSchedulesInObject(mergedSchedules),
      };
    case ADD_SCHEDULE:
      return {
        ...state,
        schedules: [...state.schedules, action.payload],
      };
    case UPDATE_SCHEDULE:
      // If properties are provided in action, use property-then-name sorting
      if (action.properties) {
        return {
          ...state,
          schedules: sortSchedulesByPropertyThenName(action.payload, action.properties),
        };
      }
      return {
        ...state,
        schedules: sortSchedulesByName(action.payload),
      };
    case DELETE_SCHEDULE:
      // If properties are provided in action, use property-then-name sorting
      if (action.properties) {
        return {
          ...state,
          schedules: sortSchedulesByPropertyThenName(action.payload, action.properties),
        };
      }
      return {
        ...state,
        schedules: sortSchedulesByName(action.payload),
      };
    case UPDATE_SCHEDULES:
      // If properties are provided in action, use property-then-name sorting
      if (action.properties) {
        return {
          ...state,
          schedules: sortSchedulesByPropertyThenName(action.payload, action.properties),
        };
      }
      return {
        ...state,
        schedules: sortSchedulesByName(action.payload),
      };
    case SET_SCHEDULES:
      return {
        ...state,
        schedules: sortSchedulesInObject(action.payload),
      };
    default:
      return state;
  }
};

export default scheduleReducer;
